// extracted by mini-css-extract-plugin
module.exports = {"dropZoneWrapper":"ChatDrop_dropZoneWrapper__3EUl8","dropZone":"ChatDrop_dropZone__2FrFK"};